import React from "react";
import { UTCDate } from "@date-fns/utc";


export const DashboardFooter = () => {
  return (
    <>
      {/* Footer */}
      <footer className="bg-gradient-to-r from-indigo-100 via-violet-100 to-purple-100 border-t border-indigo-200 py-8 shadow-inner relative overflow-hidden mt-12">
        <div className="absolute inset-0 bg-grid-indigo/5 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiM0MzM4Y2EiIGZpbGwtb3BhY2l0eT0iMC4wMyIgZD0iTTAgMGgzMHYzMEgwem0zMCAzMGgzMHYzMEgzMHoiLz48L2c+PC9zdmc+')] opacity-50"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <div className="h-8 w-8 rounded-lg bg-indigo-600/10 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-5 w-5 text-indigo-600"
                  >
                    <path d="m6 9 6-6 6 6"/>
                    <path d="m6 15 6 6 6-6"/>
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-indigo-900">MCP Dashboard</h3>
              </div>
              <p className="text-indigo-700">Connect AI tools with browser capabilities for enhanced web interactions.</p>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-4 text-indigo-900">Resources</h4>
              <ul className="space-y-3">
                <li>
                  <a href="https://github.com/modelcontextprotocol/mcp-react-ui" className="text-indigo-700 hover:text-indigo-900 transition-colors flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
                      <polyline points="14 2 14 8 20 8"/>
                    </svg>
                    Documentation
                  </a>
                </li>
                <li>
                  <a href="/docs" className="text-indigo-700 hover:text-indigo-900 transition-colors flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                    </svg>
                    Claude Code Examples
                  </a>
                </li>
                <li>
                  <a href="https://github.com/modelcontextprotocol" className="text-indigo-700 hover:text-indigo-900 transition-colors flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"/>
                      <path d="M9 18c-4.51 2-5-2-7-2"/>
                    </svg>
                    GitHub Repository
                  </a>
                </li>
                <li>
                  <a href="https://chrome.google.com/webstore/detail/mcp-extension" className="text-indigo-700 hover:text-indigo-900 transition-colors flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <rect
                        x="2"
                        y="4"
                        width="20"
                        height="16"
                        rx="2"/>
                      <path d="M2 8h20"/>
                    </svg>
                    Chrome Extension
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-4 text-indigo-900">Connect</h4>
              <div className="flex space-x-4">
                <a
                  href="https://github.com/modelcontextprotocol"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-600 hover:text-indigo-800 transition-colors p-2 bg-indigo-100/50 rounded-full hover:bg-indigo-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/></svg>
                </a>
                <a
                  href="https://twitter.com/modelcontext"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-600 hover:text-indigo-800 transition-colors p-2 bg-indigo-100/50 rounded-full hover:bg-indigo-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"><path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"/></svg>
                </a>
                <a
                  href="https://discord.gg/modelcontext"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-600 hover:text-indigo-800 transition-colors p-2 bg-indigo-100/50 rounded-full hover:bg-indigo-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"><circle cx="9" cy="12" r="1"/><circle cx="15" cy="12" r="1"/><path d="M8 9a5 5 0 0 1 8 0"/><path d="M16 9a5 5 0 0 1 8 0"/><path d="M18 9c0 9 3 12.5-4.5 12.5S9 18 9 9"/></svg>
                </a>
              </div>
            </div>
          </div>
          <div className="pt-6 border-t border-indigo-200/50 text-center">
            <p className="text-indigo-700 font-medium">© {new UTCDate().getFullYear()} <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-600 font-bold">MCP Dashboard</span> • All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};